








import { Component, Vue } from "vue-property-decorator";
import { HealthModule } from "@/store/health.module";

@Component({
  name: "MaintenanceWorks",
})
export default class extends Vue {
  intervalId: number | null = null;

  get isSystemInMaintenance() {
    return HealthModule.isSystemInMaintenance;
  }

  mounted() {
    if (process.env.VUE_APP_DISABLE_HEALTH_CHECK === "true") return;
    this.intervalId = window.setInterval(async () => {
      await HealthModule.getSystemStatus();
    }, 1000 * 60);
  }

  resetInterval() {
    if (!this.intervalId) return;
    clearInterval(this.intervalId);
  }
}
